export const requestNewServiceData = [
  {
    Question: `How do I request a new service?`,
    Answer: `Adding a new service online is easy: 

        For <strong>residential service</strong>, please visit our <a href='https://www.wm.com/us/en/home/residential-waste-recycling-pickup'>Residential Waste & Recycling page to check availability and pricing. 
        
        For <strong>business service</strong>, please visit our <a href='https://www.wm.com/us/en/business/business-waste-recycling-pickup'>Business Waste & Recycling</a> page to check availability and pricing. 
        
        For <strong>roll-off dumpster service</strong>, please visit our <a href='https://www.wm.com/us/en/dumpster-rental'>Roll-Off Dumpsters page</a> to check availability and pricing. 
        
        Looking for something else? You can browse all of WM's offerings by visiting <a href='https://www.wm.com/us/en/home'>Services for Homes or Services</a> & <a href='https://www.wm.com/us/en/business'>Solutions for Business</a>.`,
  },
]
